class SearchPatientsReq {
  constructor() {
    this.FromDate = undefined;
    this.ToDate = undefined;
    this.Name = undefined;
    this.Mobile = undefined;
    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined,
    };
  }
}

export default SearchPatientsReq;
